import {
  IReferral,
  IReferralClinicalNote,
  ReferralCollection,
} from '@principle-theorem/principle-core/interfaces';
import {
  AtLeast,
  CollectionReference,
  Firestore,
  IReffable,
  WithRef,
  multiUndeleted,
  subCollection,
} from '@principle-theorem/shared';
import { Observable } from 'rxjs';

export class ReferralClinicalNote {
  static init(
    overrides: AtLeast<IReferralClinicalNote, 'clinicalNote' | 'actor'>
  ): IReferralClinicalNote {
    return {
      deleted: false,
      ...overrides,
    };
  }

  static col(
    referral: IReffable<IReferral>
  ): CollectionReference<IReferralClinicalNote> {
    return subCollection<IReferralClinicalNote>(
      referral.ref,
      ReferralCollection.ClinicalNotes
    );
  }

  static all$(
    referral: IReffable<IReferral>
  ): Observable<WithRef<IReferralClinicalNote>[]> {
    return Firestore.query$(ReferralClinicalNote.col(referral)).pipe(
      multiUndeleted()
    );
  }
}
